import { Link } from "react-router-dom";
import { LogoMark, PHONE_TEL, PHONE_DISPLAY } from "@/lib/site";

const MARQUEE = ["Online Marketing", "Web Development", "AI Chatbots", "Booking Systems", "SEO & Search Growth", "Hosting Systems"];

export const Marquee = () => (
  <div className="border-y border-slate-200 dark:border-slate-800 py-6 overflow-hidden" aria-hidden="true">
    <div className="flex whitespace-nowrap animate-marquee w-max">
      {[...MARQUEE, ...MARQUEE].map((w, i) => (
        <span key={i} className="mx-8 font-display font-bold text-2xl sm:text-3xl tracking-tight text-slate-300 dark:text-slate-700">
          {w} <span className="text-primary/40 mx-4">✦</span>
        </span>
      ))}
    </div>
  </div>
);

export const Footer = () => (
  <footer className="py-14 border-t border-slate-200 dark:border-slate-800">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div>
          <a href="#top" className="flex items-center gap-3">
            <LogoMark className="w-9 h-9" />
            <span className="font-display font-bold text-lg tracking-tight">Wynova<span className="text-primary"> Systems</span></span>
          </a>
          <p className="mt-4 max-w-sm text-sm text-slate-500 dark:text-slate-400">
            High-impact marketing, bespoke web development, and resilient hosting systems — one integrated growth engine.
          </p>
        </div>
        <nav className="flex flex-wrap gap-x-8 gap-y-3 text-sm font-medium text-slate-600 dark:text-slate-300">
          <a href="#services" className="hover:text-primary transition-colors">Services</a>
          <a href="#hosting" className="hover:text-primary transition-colors">Hosting Tiers</a>
          <a href="#cases" className="hover:text-primary transition-colors">Case Studies</a>
          <Link to="/seo" data-testid="footer-seo-link" className="hover:text-primary transition-colors">SEO Packages</Link>
          <a href="#contact" className="hover:text-primary transition-colors">Contact</a>
          <a href={PHONE_TEL} data-testid="footer-phone-link" className="hover:text-primary transition-colors">Call {PHONE_DISPLAY}</a>
          <Link to="/admin" data-testid="footer-admin-link" className="text-slate-400 hover:text-primary transition-colors">Admin</Link>
        </nav>
      </div>
      <div className="mt-10 pt-6 border-t border-slate-200 dark:border-slate-800 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-400">
        <p>© {new Date().getFullYear()} Wynova Systems. All rights reserved.</p>
        <p>Managing Director: Lual Achour · Operations Director: Wilson Lual</p>
      </div>
    </div>
  </footer>
);
